import React, { useState } from 'react';
import { Box } from '@mui/material';
import AvatarImg from 'pages/components/avatarImg';
import { getUrl } from 'utilities/userImageURL';
import TypographyWithI18N from 'pages/components/TypographyWithI18N';
import { colors } from 'styles/colors';
import { useNavigate } from 'react-router-dom';
import { IGuestModeOptions } from 'models/apiPaths';
import SigninModal from 'pages/components/signinModal';

interface IActiveUsersProps {
  activeUsersList: any[];
  isLoggedIn?: boolean;
}

const ActiveUsers = ({ activeUsersList, isLoggedIn }: IActiveUsersProps) => {
  const [guestModeOptions, setGuestModeOptions] = useState<IGuestModeOptions>({
    guestMode: false,
    navigateTo: null,
    menu: null,
    redirectTo: null,
    action: null,
    actionItem: null
  });
  const [openSigninDialog, setOpenSigninDialog] = useState<boolean>(false);
  const navigate = useNavigate();
  return (
    <Box
      id='active_userList'
      sx={{
        display: 'flex',
        gap: 2,
        overflowX: 'auto',
        paddingX: 5,
         width: '100%',       
         boxSizing: 'border-box'  
      }}
    >
      {activeUsersList.map((item, index) => (
        <Box
          sx={{
            cursor: 'pointer',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}
          key={index.toString()}
          onClick={() => {
            if (isLoggedIn) {
              navigate(`/profile/${item?.id}`)
            } else {
              setGuestModeOptions({
                guestMode: true,
                navigateTo: 'profile',
                menu: 'profile',
                redirectTo: `/profile/${item?.id}`,
                action: 'profile',
                actionItem: null
              });
              setOpenSigninDialog(true);
            }
          }}
        >
          <AvatarImg
            id='userImg'
            enableLetterImg={item?.userImage?.id ? false : true}
            alt={item?.username}
            src={getUrl(item?.userImage?.id)}
            name={item?.username}
            nameStyle={{
              fontSize: 18
            }}
            width={66}
            height={66}
            style={{
              objectFit: 'cover',
              borderRadius: '50%'
            }}
          />
          <TypographyWithI18N
            id='title'
            className='ellipsisText'
            maxWidth={50}
            sx={{
              color: colors.text.primaryBlack
            }}
            i18nKey={item?.username}
            tabIndex={0}
          />
        </Box>
      ))}
      {(
        openSigninDialog && (
          <SigninModal
            guestModeOptions={guestModeOptions}
            openSigninDialog={openSigninDialog}
            closeSigninDialog={() => {setOpenSigninDialog(false)}}
          />
        )
      )}
    </Box>
  );
};

export default ActiveUsers;
